import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Fails when a control that originally had a value is cleared.
 * Pass the original value; the validator is a no-op when the field started empty,
 * so empty-on-init fields can stay empty while populated ones cannot be cleared.
 */
export function notClearableValidator(originalValue: unknown): ValidatorFn {
  const hadValue = originalValue !== null && originalValue !== undefined && originalValue !== '';

  return (control: AbstractControl): ValidationErrors | null => {
    if (!hadValue) {
      return null;
    }
    const isEmpty = control.value === null || control.value === undefined || control.value === '';
    return isEmpty ? { notClearable: true } : null;
  };
}
